/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/display-name */
import React, { useImperativeHandle } from 'react'

import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'

interface Props {
  'aria-label'?: any
  badge?: any
  badgeInfo?: any
  btnClassName?: any
  className?: any
  displayName?: any
  icon?: any
  id?: any
  inputProps?: any
  isAccordionToggle?: boolean
  isClick?: any
  isFixedPopup?: any
  label?: any
  name?: any
  onClick?: any
  onScroll?: any
  parentScrollPosition?: any
  popupCloseOpenFunctionality: (
    params: any,
    a: any,
    b: any,
    c: any,
    d: any,
    f: any,
    g: any,
    h?: any,
    j?: any,
    k?: any
  ) => any
  props?: any
  rIcon?: any
  ref?: any
  reference?: any
  showHide?: any
  type?: any
}
const ActionButtons = React.forwardRef((props: Props, ref: any) => {
  const { parentScrollPosition } = props
  let showHide = false
  useImperativeHandle(ref, () => ({
    buttonRefs: () => {
      showHide = false
    },
  }))
  const popupOpenClose = (ele: any) => {
    if (props?.onClick) {
      props?.onClick()
    }
    const elementHeight = ele.currentTarget.offsetHeight
    const offSetTopValue = ele.currentTarget.offsetTop
    const elementRect = ele?.currentTarget?.getBoundingClientRect()
    const fixedPopUpTopValue = elementHeight + elementRect?.top + parentScrollPosition
    const fixedPopUpLeftValue = elementRect?.left
    const offsetWidthValue = ele.currentTarget.offsetWidth
    const offsetLeftValue = ele.currentTarget.offsetLeft
    const popupTop = elementHeight + offSetTopValue
    const popupLeft = offsetWidthValue + offsetLeftValue
    const data = ele.currentTarget.attributes

    let displayName = ''
    for (const element of data) {
      if (element.nodeName === 'value' && element.nodeValue === 'false') {
        showHide = true
      }
      if (element.nodeName === 'data-displayname') {
        displayName = element.nodeValue
      }
    }

    props?.props?.popupCloseOpenFunctionalityWork(displayName)
    props?.popupCloseOpenFunctionality(
      displayName,
      showHide,
      popupTop,
      popupLeft,
      offsetLeftValue,
      elementHeight,
      offsetWidthValue,
      fixedPopUpTopValue,
      fixedPopUpLeftValue
    )
    if (props?.isAccordionToggle) {
      props?.popupCloseOpenFunctionality(
        props?.id,
        showHide,
        popupTop,
        popupLeft,
        offsetLeftValue,
        elementHeight,
        offsetWidthValue
      )
      ele?.stopPropagation()
      ele?.preventDefault()
    }
    if (props?.isFixedPopup) {
      props?.popupCloseOpenFunctionality(
        props?.id,
        showHide,
        popupTop,
        popupLeft,
        offsetLeftValue,
        elementHeight,
        offsetWidthValue,
        fixedPopUpTopValue,
        fixedPopUpLeftValue
      )
      ele?.stopPropagation()
    }
  }
  return (
    <div
      className={
        props?.btnClassName ? `button-container ${props?.btnClassName}` : 'button-container'
      }
    >
      <button
        aria-label={props['aria-label'] || props?.label}
        className={`btn ${props?.className}`}
        data-displayname={props?.isClick}
        id={props?.id}
        onClick={popupOpenClose}
        title={props['aria-label'] || props?.label}
        type={props?.type || 'button'}
        value={props?.showHide}
      >
        {props?.icon && <span className={props?.icon}></span>}
        {defaultToEmptyString(props?.name)}
        {props?.rIcon && <span className={props?.rIcon}></span>}
        {props?.badgeInfo && <sup className={props?.badge}>{props?.badgeInfo}</sup>}
      </button>
    </div>
  )
})
export default ActionButtons
